import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface CompletePickemParams {
  pickemId: string;
}

export async function completePickem({ pickemId }: CompletePickemParams) {
  const response = await api.post(apiEndpoints.completePickem(pickemId), {
    confirmScoring: true,
  });
  return response.data;
}

export function useCompletePickemMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: completePickem,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      toast.success('Pickem completed and scoring initiated');

      // Reload the page after a short delay to show the toast
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.error || 'Failed to complete pickem');
    },
  });
}
